import { useAuth0 } from '@auth0/auth0-react';

/**
 * The address the current session belongs to, shown under the store picker.
 *
 * Orderbot never displayed this anywhere, which is survivable until someone
 * holds two accounts with different roles on the same store — then a refusal is
 * indistinguishable from a broken app, for the user and for whoever they call.
 *
 * Size, not colour, carries the hierarchy: it takes the same gray-300 as the
 * nav's own links so it stays legible on the dark bar. The one moment it
 * matters is the moment someone is squinting at it to work out why the app is
 * refusing them, which is a poor moment to have dimmed it for tidiness.
 *
 * The right padding is 9px rather than the store button's 12px so the address
 * ends level with the chevron's *visible* edge. StoreMenu's ChevronDownIcon
 * carries `-mr-2`, pulling its 20px box 8px past the button's `px-3`, and the
 * glyph is drawn 5px inside that box (heroicons 20/solid, rendered 1:1): the
 * chevron therefore lands 12 - 8 + 5 = 9px in. Mirroring `px-3` here left the
 * address 3px shy of it — small, but the two sit stacked and right-aligned,
 * which is exactly the arrangement that makes 3px legible.
 */
export function SignedInAs() {
  const email = useAuth0().user?.email;

  if (!email) {
    return null;
  }

  return (
    <span
      className="max-w-[16rem] truncate pl-3 pr-[9px] text-[11px] leading-none text-gray-300"
      title={`Signed in as ${email}`}
    >
      {email}
    </span>
  );
}
